import React from 'react'
import ProductGrid from '../components/Product/allProductGrid.jsx'
import {useParams} from "react-router-dom";

function Allstore() {

    let {pageURL} = useParams();
    //  console.log(pageURL);
    if(!pageURL){ pageURL = 0}

    return (
        <>
            <ProductGrid pageURL={pageURL} />
        </>
    )
}

export default Allstore
